import solarLoader from '@/components/misc/solar-loader.vue'

export default {
	name	: 'button-load-more',
	components: {
		'solar-loader': solarLoader
	},
	props	: {
		isLoading		: {
			type		: Boolean,
			default		: false
		},
		totalListLength	: {
			type		: Number,
			default		: 0
		},
		listLength		: {
			type		: Number,
			default		: 0
		},
		loader			: {
			type		: String,
			default		: "default"
		}
	},
	methods	: {
		changeBtn() {
			this.$emit('change-btn')
		}
	}
}
